<template>
  <div class="app-container bj-label-colon">
    <BjDivider right-fixed
      >{{ $t('BusinessStockEntryInformView.title') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="reFresh">{{ $t('refreshText') }}</el-button>
        <BjLogButton
          :id="data.id"
          permission="BusinessStockEntryInformIndex_Log"
          :title="data.code"
          api="stockApi"
        />
      </template>
    </BjDivider>
    <el-row>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('BusinessStockEntryInformView.code')">
            {{ data.code || noDataText }}
            <BjCopyIcon class="ml10" :copy="data.code" />
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.receivingLogicWarehouseCode')">
            {{ data.receivingLogicWarehouseCode || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.receivingLogicWarehouseName')">
            {{ data.receivingLogicWarehouseName || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.inputTypeMeaning')">
            {{ data.inputTypeMeaning || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.statusMeaning')">
            {{ data.statusMeaning || noDataText }}
          </el-form-item>
          <!-- <el-form-item label="买家备注">
            {{ data.buyMsg || noDataText }}
          </el-form-item>
          <el-form-item label="商家备注">
            {{ data.orderMsg || noDataText }}
          </el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('BusinessStockEntryInformView.returnsName')">{{ data.returnsName || noDataText }} </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.returnsMobile')">{{ data.returnsMobile | phoneFilter }} </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.cptAddress')">{{ cptAddress }} </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryInformView.creationDate')">
            {{ data.creationDate || noDataText }}
          </el-form-item>
          <!-- <el-form-item label="创建人">
            {{ data.createdName || noDataText }}
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <BjDivider>{{ $t('BusinessStockEntryInformView.logisticsInformation') }}</BjDivider>
      <el-col :span="24">
        <el-form>
          <el-form-item label="">
            {{
              data.logisticsList
                .map(item => `${item.logisticsCompanyName} - ${item.logisticsNo}`)
                .join('；')
            }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <BjDivider>{{ $t('BusinessStockEntryInformView.associated') }}</BjDivider>
      <el-form inline>
        <el-col :span="8">
          <!--
            TODO: 根据类型跳转
frontRecordCode (string, optional): 前置业务单号 ,
frontRecordId (integer, optional): 前置业务id ,
frontRecordType (string, optional): 前置业务单号类型 ,
           -->
          <el-form-item :label="$t('BusinessStockEntryInformView.frontRecordCode')">
            <span @click="onView(0)">{{ data.frontRecordCode }}</span>
            <BjCopyIcon class="ml10" :copy="data.frontRecordCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryInformView.orderCode')">
            <span class="link" @click="$toBusinessOrderInternalView(data.orderCode)">{{
              data.orderCode
            }}</span>
            <BjCopyIcon class="ml10" :copy="data.orderCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryInformView.platformOrderCode')">
            <span class="link" @click="$toBusinessThirdOrderView(data.platformOrderCode)">{{
              data.platformOrderCode
            }}</span>
            <BjCopyIcon class="ml10" :copy="data.platformOrderCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryInformView.resultCode')">
            <span class="link" @click="$toBusinessStockEntryResultView(data.resultCode)">{{
              data.resultCode
            }}</span>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <BjDivider>{{ $t('BusinessStockEntryInformView.productInformation') }}</BjDivider>
    <!-- TODO:商品明细应该只有一条 by skyer-ebc-325 -->
    <BjPage
      ref="BjPage"
      :col-span="colSpan"
      :get-action="queryApi"
      :query-params="queryParams"
      :auto-fetch="false"
      :serial="serial"
      :selection="false"
      :stripe="false"
      search-btn-hide
      right-toolbar-hide
      row-key="id"
      no-auto-height
      @handleSelectionChange="handleSelectionChange"
    >
      <template #tableColumn>
        <!-- <el-table-column :label="$t('goodsPage.spuCode')" prop="spuCode" align="center" /> -->
        <el-table-column :label="$t('BusinessStockEntryInformView.table.skuName')" prop="skuName" align="center" />
        <el-table-column :label="$t('BusinessStockEntryInformView.table.skuCode')" prop="skuCode" align="center" />
        <el-table-column :label="$t('BusinessStockEntryInformView.table.plannedQty')" prop="plannedQty" align="center" />
        <el-table-column :label="$t('BusinessStockEntryInformView.table.alreadyInputQty')" prop="alreadyInputQty" align="center" />
        <!-- <el-table-column :label="$t('goodsPage.spuName')" prop="spuName" align="center" /> -->
      </template>
      <template #paginationLeft>
        <span>{{ $t('BusinessStockEntryInformView.totalQty') }}：{{ data.totalQty }} </span
        ><span class="ml20">{{ $t('BusinessStockEntryInformView.alreadyTotalQty') }}：{{ data.alreadyTotalQty }}</span>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
export default {
  name: 'BusinessStockEntryInformView',
  components: {},
  mixins: [pageMiXin, viewMiXin],
  props: {},
  data() {
    return {
      queryApi: stockApi.getEntryInformDetailGoods,
      queryParams: {
        warehouseWarrantId: null,
      },
      colSpan: 12,
      id: null,
      data: {
        alreadyTotalQty: null,
        channelTypeCode: null,
        channelTypeCodeMeaning: null,
        city: null,
        code: null,
        country: null,
        creationDate: null,
        district: null,
        frontRecordCode: null,
        frontRecordId: null,
        frontRecordType: null,
        id: null,
        inputType: null,
        inputTypeMeaning: null,
        logisticsList: [
          // {
          //   logisticsCompanyName: null,
          //   logisticsNo: null,
          // },
        ],
        orderCode: null,
        platformOrderCode: null,
        province: null,
        receivingLogicWarehouseCode: null,
        receivingLogicWarehouseName: null,
        returnsAddress: null,
        returnsMobile: null,
        returnsName: null,
        returnsTel: null,
        status: null,
        statusMeaning: null,
        storeName: null,
        totalQty: null,
      },
      noDataText: this.$t('BusinessStockEntryInformView.noDataText'),
    };
  },
  computed: {
    cptAddress() {
      let text = '';
      text += this.data.province || '';
      text += this.data.city || '';
      text += this.data.district || '';
      text += this.data.returnsAddress || '';
      return text;
    },
  },
  created() {
    this.reFresh();
  },
  mounted() {},
  methods: {
    reFresh() {
      stockApi
        .detailEntryInform({ id: this.$route.query.id, code: this.$route.query.code })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.data = Object.assign({}, this.data, res || {});
            if (this.data.id) {
              this.queryParams.warehouseWarrantId = this.data.id;
              this.$refs.BjPage.fetchData();
            }
          }
        });
    },
    onView(type) {
      switch (type) {
        case 0:
          // TODO: 这里需要以后过来接，现在没数据
          // this.msgSuccess('跳转前置页面');
          break;
        case 1:
          this.$toBusinessOrderInternalView(this.data.orderCode);
          break;
        case 2:
          // TODO: 这里需要以后过来接，现在没数据
          this.$toBusinessThirdOrderView(this.data.platformOrderCode);
          break;
      }
    },
    handleClose() {
      this.cancel();
    },
    /** 查看更多 */
    onMore() {
      this.$refs.codeTable.show(this.data.logisticsList);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item {
  margin-bottom: 5px;
}
</style>
